export default __webpack_public_path__ + "static/media/lung.5ba4b57e.jpg";